import React from 'react';
import { Skeleton } from 'antd';

const CourseSkeleton = () => (
  <div className="rounded-xl bg-white">
    <Skeleton.Node className="!h-35 !w-full !rounded-t-xl" active />
    <div className="flex items-end justify-between p-2 pb-4">
      <div className="flex items-start gap-2">
        <Skeleton.Avatar size={35} active />
        <div className="flex h-12 flex-col justify-between">
          <div className="flex flex-col">
            <Skeleton.Node className="!w-26 !h-3 !rounded-lg" active />
            <Skeleton.Node className="!w-19 !h-2 !rounded-lg" active />
          </div>
          <Skeleton.Node className="!w-15 !h-2 !rounded-lg" active />
        </div>
      </div>
      <Skeleton.Node className="!w-15 !h-2 !rounded-lg" active />
    </div>
  </div>
);

export default CourseSkeleton;
